module.exports = __webpack_public_path__ + "static/img/CALEB-MAY.3f90f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CALEB-MAY.jpg
// module id = xibL
// module chunks = 0